import { lazy } from "react";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";

const LifeInsuranceInvoiceWrapper = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceInvoices/LifeInsuranceInvoiceWrapper"
      ).then(({ LifeInsuranceInvoiceWrapper }) => ({
        default: LifeInsuranceInvoiceWrapper,
      }))
    )
  );

const LifeInsuranceInvoiceTabs = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceInvoices/LifeInsuranceInvoiceTabs"
      ).then(({ LifeInsuranceInvoiceTabs }) => ({
        default: LifeInsuranceInvoiceTabs,
      }))
    )
  );

const LifeInsuranceInvoiceHistoryWrapper = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceInvoices/LifeInsuranceInvoiceHistoryWrapper"
      ).then(({ LifeInsuranceInvoiceHistoryWrapper }) => ({
        default: LifeInsuranceInvoiceHistoryWrapper,
      }))
    )
  );

const LifeInsuranceBulkInvoiceWrapper = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceInvoices/LifeInsuranceBulkInvoiceWrapper"
      ).then(({ LifeInsuranceBulkInvoiceWrapper }) => ({
        default: LifeInsuranceBulkInvoiceWrapper,
      }))
    )
  );
const LifeInsuranceInvoicePaymentWrapper = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceInvoices/LifeInsuranceInvoicePaymentWrapper"
      ).then(({ LifeInsuranceInvoicePaymentWrapper }) => ({
        default: LifeInsuranceInvoicePaymentWrapper,
      }))
    )
  );
const LifeInsuranceAllTask = Loadable(
    lazy(() =>
      import(
        "./LifeInsuranceNoteForm/LifeInsuranceNotesList"
      ).then(({ LifeInsuranceNotesList }) => ({
        default: LifeInsuranceNotesList,
      }))
    )
  );

const LifeInsurancePolicyContacts = Loadable(
    lazy(() =>
      import(
        "./LifeInsurancePolicyContacts/LifeInsurancePolicyContacts"
      ).then(({ LifeInsurancePolicyContacts }) => ({
        default: LifeInsurancePolicyContacts,
      }))
    )
  );

export const LifeInsurancePolicyRouter = [
    {
        path: "/life-insurance-policy/:customerId/invoices/:customerPolicyId/manage",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceInvoiceWrapper />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/invoices/:customerPolicyId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceInvoiceTabs />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/invoices/:customerPolicyId/payment/history/:invoiceId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceInvoiceHistoryWrapper />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/invoices/:customerPolicyId/bulk-invoice",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceBulkInvoiceWrapper />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/invoices/payments/:customerPolicyId/manage",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceInvoicePaymentWrapper />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/all-tasks/:customerPolicyId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsuranceAllTask />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/life-insurance-policy/:customerId/contacts/:customerPolicyId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
            <LifeInsurancePolicyContacts />
          </AuthorizedRoute>
        ),
      },
];